export default {"src":"/_next/static/media/Arrhythmias.1e017044.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};